import { Link } from "react-router-dom";
import { stats } from "@/mocks/site";
import { topics } from "@/mocks/topics";
import { formatHeat, getCategoryName, statusMeta } from "@/utils/news";

export default function Hero() {
  const featured = topics[0];
  const status = statusMeta(featured.status);

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20background%20with%20warm%20vermilion%20amber%20and%20deep%20brown%20gradient%20waves%2C%20paper%20grain%20texture%2C%20soft%20light%20rays%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20no%20people&width=1800&height=1000&seq=kb-home-hero-01&orientation=landscape"
          alt="蝌蚪爆料首页背景图"
          title="蝌蚪爆料 - 热议发酵追踪"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/40"></div>
      </div>

      <div className="relative w-full px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
          <div className="animate-rise">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/50 bg-primary-500/15 px-3 py-1 text-xs font-medium text-primary-200">
              <i className="ri-live-line text-sm" aria-hidden="true"></i>
              持续更新中 · 今日新增 12 条进展
            </span>

            <h1 className="mt-5 flex items-center gap-3 font-heading text-4xl font-bold leading-tight text-background-50 md:text-5xl">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-2xl text-background-50 md:h-14 md:w-14 md:text-3xl">
                蝌
              </span>
              蝌蚪爆料
            </h1>

            <p className="mt-5 max-w-xl text-base leading-relaxed text-background-200 md:text-lg">
              把一件热点从「怎么火的」「吵什么」「谁回应了」到「哪些是谣言」按时间讲清楚。
              花几分钟看完重点，吃瓜不被带节奏。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#latest"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
                查看今日热议
              </a>
              <Link
                to="/category/piyao"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-400/60 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-shield-check-line text-base" aria-hidden="true"></i>
                先去看看辟谣核查
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs text-background-300">{item.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-bold text-background-50">
                    {item.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="animate-rise">
            <div className="rounded-lg border border-background-500/40 bg-background-50/10 p-2 backdrop-blur-sm">
              <div className="rounded-md bg-background-50 p-4">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium text-foreground-500">当前热度最高 · 焦点事件</span>
                  <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${status.className}`}>
                    <i className={`${status.icon} text-xs`} aria-hidden="true"></i>
                    {status.label}
                  </span>
                </div>

                <Link to={`/topic/${featured.id}`} className="group mt-3 block">
                  <h2 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                    {featured.title}
                  </h2>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {featured.tagline}
                  </p>
                </Link>

                <div className="mt-4 grid grid-cols-3 gap-2 border-t border-background-200 pt-3 text-center">
                  <div>
                    <p className="font-heading text-lg font-bold text-primary-600">{formatHeat(featured.heat)}</p>
                    <p className="text-[11px] text-foreground-500">讨论热度</p>
                  </div>
                  <div>
                    <p className="font-heading text-lg font-bold text-foreground-900">{featured.timeline.length}</p>
                    <p className="text-[11px] text-foreground-500">关键节点</p>
                  </div>
                  <div>
                    <p className="font-heading text-lg font-bold text-secondary-600">{featured.factChecks.length}</p>
                    <p className="text-[11px] text-foreground-500">核查结论</p>
                  </div>
                </div>

                <Link
                  to={`/topic/${featured.id}`}
                  className="mt-4 flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
                >
                  查看完整时间线
                  <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                </Link>

                <p className="mt-3 text-center text-[11px] text-foreground-400">
                  {getCategoryName(featured.category)} · 更新于 {featured.updatedAt}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}